@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.error-warn-modal-body {
  padding: 0;
  background-color: @label-batch-status--error-warn-body--background-color;
  max-height: 600px;
  max-width: 900px;
}

.error-warn-header {
  padding: 10px 20px;
  background-color: @label-batch-status--error-warn-header--error--background-color;

  .instructions {
    font-size: 14px;
  }
}

.error-warn-collection {
  background-color: @label-batch-status--error-warn-collection--background-color;
  padding: 10px 20px;
  border-top: 1px solid @label-batch-status--error-warn-collection--border-color;
}

.error-warn-footer {
  display: flex;
  justify-content: space-between;
}

.error-warn-cancel-button {
  color: @label-batch-status--error-warn-cancel-button--text-color;

  &:hover {
    color: @label-batch-status--error-warn-cancel-button--hover--text-color;
    cursor: pointer;
  }
}
